<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title primary-title class="headline grey lighten-3">
        CAPITAL TRNS
      </v-card-title>
      <v-card flat>
        <v-card-title>
          <!-- {{ TranInfo.FullName }} -->
          <!-- <div>
            <cashDisplay
              :isloading="isloading"
              :Balance="OldBalanceArray"
              colorName="black"
            ></cashDisplay>
          </div> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            dense
            solo
            outlined
            append-icon="mdi-search"
            label="Search"
            single-line
            hide-details
            class="d-print-none mr-5"
          ></v-text-field>
          <v-radio-group v-if="trnsList.length" row v-model="MyCash">
            <v-radio label="All" value="all"></v-radio>

            <v-radio
              :key="cash.AmountType"
              v-for="cash in TotalSale"
              :label="cash.AmountType"
              :value="cash.AmountType"
            ></v-radio>
          </v-radio-group>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            v-if="sortedItems.length"
            icon
            class="d-print-none"
            small
            color="success"
            @click="PrintPage"
          >
            <v-icon>fas fa-print</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <DepositCapital :Onfinished="OpenTranDialog" />
          <CapwithDraw :Onfinished="OpenTranDialog" />
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="sortedItems"
          :search="search"
          dense
          fixed-header
          :items-per-page="itemPerPage"
        >
          <template v-slot:[`item.Details`]="{ item }">
            <slot name="Details" :row="item">
              {{ item.Details }}
            </slot>
          </template>
          <template v-slot:[`item.deposit`]="{ item }">
            <slot name="deposit" :row="item">
              <template v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </slot>
          </template>
          <template v-slot:[`item.withdraw`]="{ item }">
            <slot name="withdraw" :row="item">
              <template v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </slot>
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ item.total && item.total.toLocaleString() }}
            {{ item.AmountType | MoneySigns }}
          </template>
        </v-data-table>
        <!-- <p>{{ InOUtBlc }}</p> -->
        <v-card-actions class="d-flex flex-column flex-md-row justify-end ">
          <InOut
            v-for="(cash, index) in InOUtBlc"
            :key="index"
            :Total="cash"
          ></InOut>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
// import cashDisplay from "@/components/util/displayCash.vue";
// import searchDate from "@/components/util/searchDate.vue";
import InOut from "@/components/util/InOut.vue";
// import axios from "axios";
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";

export default {
  mixins: [printTable],
  props: {
    // CustomerID: { type: Object, required: true },
  },
  components: {
    // cashDisplay,
    // searchDate,
    InOut,
    DepositCapital: () => import("./Dep_with/CapDeposit.vue"),
    CapwithDraw: () => import("./Dep_with/CapwithDraw.vue"),
  },
  data() {
    return {
      BaseURL: "/Reports/cash/DhigidHanti",
      MyCash: "all",
      mainDialgo: false,
      dialog: false,
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      OldBalanceArray: [],
      AvailibleBalanceArray: [],
      trnsList: [],
      EmptyMessage: "",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details", sortable: false },
        // { text: "Cash Type", value: "AmountType", sortable: false },
        { text: "IN", value: "deposit", sortable: false },
        {
          text: "OUT",
          value: "withdraw",
          class: "blue--text",
          sortable: false,
        },
        { text: "User", value: "User", sortable: false },
        { text: "Ref", value: "Ref", sortable: false },
      ],
    };
  },
  computed: {
    sortedItems() {
      if (this.MyCash == "all") return this.trnsList;
      return this.trnsList.filter(trn => trn.AmountType == this.MyCash);
    },
    InOUtBlc() {
      if (!this.sortedItems.length) return [];

      let total = this.sortedItems.reduce((result, item) => {
        let Current = result[item.AmountType] || { Cr: 0, Dr: 0 };

        result[item.AmountType] = {
          ...(result[item.AmountType] || Current),
          [item.Acc]: Current[item.Acc] + Math.abs(item.Amount),
          Cash: item.AmountType,
        };
        return result;
      }, {});
      return total;
      //   return Object.keys(total).map(key => total[key]);
    },
    TotalSale() {
      if (!this.trnsList.length) return [];

      let total = this.trnsList.reduce((result, item) => {
        let { Amount } = result[item.AmountType] || { Amount: 0 };
        result[item.AmountType] = {
          Amount: Amount + item.Amount,
          AmountType: item.AmountType,
        };
        return result;
      }, {});
      // console.log(total);
      return Object.keys(total).map(key => total[key]);
    },
  },
  methods: {
    async PrintPage() {
      let prHeader = [
        { value: "index", text: "#" },
        ...this.headers.filter(head => head.text !== "Ref"),
      ];
      let myTitle = `Capital Transactions`;
      const myPrintTable = this.PrintReport(
        this.sortedItems.reverse(),
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle(),
        repeatTableHeader: false,
      });
    },
    OpenTranDialog() {
      //   console.log("this");
      // let { Thismonth, date } = this.Current();
      //   console.log(this.Current());
      this.trnsList = [];
      this.searching = true;
      this.isloading = true;
      // this.AvailibleBalanceArray = [];
      // this.OldBalanceArray = [];

      this.TranSactions()
        .then(({ data }) => {
          this.isloading = false;
          this.searching = false;
          this.trnsList = data || [];
          // this.AvailibleBalanceArray = blc || [];
          // this.OldBalanceArray = old || [];
          // console.log(data);
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    TranSactions() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}`,
      });
    },

    close() {
      this.dialog = false;
    },
  },
  created() {
    this.OpenTranDialog();
  },
};
</script>
